import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ListChildComponentProps } from 'react-window';

import { IFilterListItem } from 'common/types';
import { LIST_PADDING } from 'common/constants/filterList';
import { Checkbox } from 'common/components/Checkbox';

export interface IFilterListRowData {
    items: IFilterListItem[];
    selected: Set<string>;
    onToggle: (value: string) => void;
}

export const FilterListRow = ({
    index,
    style,
    data,
}: ListChildComponentProps<IFilterListRowData>) => {
    const { items, selected, onToggle } = data;
    const item = items[index];
    const checked = selected.has(item.value);

    return (
        <ListItemButton
            dense
            disableGutters
            disabled={item.disabled}
            style={{ ...style, top: Number(style.top) + LIST_PADDING }}
            sx={{ '&:hover': { bgcolor: 'transparent' } }}
            onClick={() => onToggle(item.value)}
        >
            <ListItemIcon sx={{ minWidth: 0, mr: 0.5 }}>
                <Checkbox
                    disableRipple
                    checked={checked}
                    edge="start"
                    slotProps={{ input: { 'aria-label': item.label } }}
                    tabIndex={-1}
                />
            </ListItemIcon>
            <ListItemText
                primary={item.label}
                slotProps={{ primary: { noWrap: true } }}
            />
        </ListItemButton>
    );
};
